// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3YmXg","container":"styles_container__2qk9E","title":"styles_title__2pT5d","wrapper":"styles_wrapper__3pKRf","answer":"styles_answer__pJpQP"};